import ctl from '@netlify/classnames-template-literals';

const sectionContainer = ctl(`
  flex
  gap-4
  w-full 
  max-w-[1000px] 
  mt-4 
  mb-4
`);

const reportContainer = ctl(`
  w-1/2
  p-4
  border
  rounded-lg
  border-light-gray 
  bg-white 
  shadow-sm 
`);

const reportHeader = ctl(`
  text-lg 
  font-semibold  
  text-white 
  py-2 px-4 
  rounded-md 
  text-center 
  mb-4
`);

export default {
  sectionContainer,
  reportContainer,
  reportHeader,
};
